import api from './api';

export const getAgentList = async (params = {}) => {
  try {
    const body = {
      page: params.page || 1,
      pageSize: params.pageSize || params.page_size || 200, 
      orderBy: params.orderBy || params.order_by || "created_at",
      orderDirection: params.orderDirection || params.order_direction || "DESC",
      filters: params.filters || {},
    };

    if (params.search) {
      body.search = params.search;
    }

    const response = await api.post(`/v1/workspace/agent/list`, body);
    
    return {
      data: {
        agents: response.data?.data || [],
        requestId: response.data?.requestId || null,
        msgCode: response.data?.msgCode || null,
        meta: response.data?.meta || null
      }
    };
  } catch (error) {
    console.error('Error fetching agents list:', error);
    throw error;
  }
};

export const updateAgent = async (uuid, body) => {
  try {
    const response = await api.post(`/v1/workspace/agent/update`, {
      uuid: uuid,
      name: body.name,
      description: body.description,
      tenant_id: body.tenant_id,
      metadata: {
        ...(body.metadata || {}),
        conversation_starters: body.starters || []
      },
      owner: body.owner,
      created_by: body.created_by,
      status: body.status,
      // is_active: body.is_active !== undefined ? body.is_active : body.status === 'active',
      type: body.type,
      version: body.version,
      scope: body.scope,
      tags: body.tags,
      category: body.category,
      starters: body.starters || [],
      image: body.image || '',
      signature: body.signature || ''
    });
    return response;
  } catch (error) {
    console.error('Error updating agent:', error);
    throw error;
  }
};

export const getAgentById = async (id) => {
  try {
    const response = await api.get(`/v1/workspace/agent/${encodeURIComponent(id)}`);
    // La nueva respuesta viene envuelta: { statusCode, body, ... }
    // Extraer el body que contiene el agente
    const agentData = response.data?.body || response.data;
    
    // Devolver en formato compatible: { data: agentData }
    // Esto mantiene compatibilidad con response?.data en AgentContext
    // y con const { data } = await getAgentById(uuid) en agentStore
    return {
      data: agentData
    };
  } catch (error) {
    console.error(`Error fetching agent with id ${id}:`, error);
    throw error;
  }
};

export const getDocumentsByAgent = async (id) => {
  try {
    const response = await api.get(`/v1/workspace/agent/${encodeURIComponent(id)}/documents/list`);
    return response;
  } catch (error) {
    console.error(`Error fetching documents for agent ${id}:`, error);
    throw error;
  }
};

export const getDrivesByAgent = async (id) => {
  try {
    const response = await api.get(`/v1/workspace/agent/${encodeURIComponent(id)}/drives/list`);
    return response;
  } catch (error) {
    console.error(`Error fetching drives for agent ${id}:`, error);
    throw error;
  }
};



export const getAgentInstruction = async (agentUuid) => {
  try {
    const response = await api.get(`/v1/workspace/agent/${encodeURIComponent(agentUuid)}/instruction`);
    return response;
  } catch (error) {
    console.error(`Error fetching agent instruction with uuid ${agentUuid}:`, error);
    throw error;
  }
};

export const addInstructionToAgent = async (agentUuid, instructionUuid) => {
  try {
    const response = await api.post(
      `/v1/agents/${encodeURIComponent(agentUuid)}/instruction`,
      {
        instruction_uuid: instructionUuid
      }
    );
    return response;
  } catch (error) {
    console.error(`Error assigning instruction to agent ${agentUuid}:`, error);
    throw error;
  }
};

export const createAgent = async (body) => {
  try {
    const response = await api.post(`/v1/workspace/agent/create`, body);
    return response;
  } catch (error) {
    console.error('Error creating agent:', error);
    throw error;
  }
};

// TODO: Implementar cuando esté listo el endpoint
// export const deleteAgent = async (uuid) => {
//   try {
//     const response = await api.post(`/v1/workspace/agent/delete/${encodeURIComponent(uuid)}`, {});
//     return response;
//   } catch (error) {
//     console.error(`Error deleting agent with uuid ${uuid}:`, error);
//     throw error;
//   }
// };

export const getAgentListV2 = async (params = {}) => {
  try {
    const body = {
      page: params.page || 1,
      pageSize: params.pageSize || params.page_size || 20,
      orderBy: params.orderBy || params.order_by || "created_at",
      orderDirection: params.orderDirection || params.order_direction || "DESC",
      filters: params.filters || {},
    };

    // Add search if provided
    if (params.search) {
      body.search = params.search;
    }

    // Usar api en lugar de axios para incluir autorización automática
    const response = await api.post(`/v1/workspace/agent/list`, body);
    return response.data;
  } catch (error) {
    console.error('Error fetching agents list v2:', error);
    throw error;
  }
};